var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback, useMemo } from 'react';
import { Tooltip } from 'react-tippy';
import { PROFFIT_SEARCH_ACTION_TOOLTIP_BLOCK_SHARE, PROFFIT_SEARCH_ACTION_TOOLTIP_IS_NOT_READY_PPTX, PROFFIT_SEARCH_ACTION_TOOLTIP_LIMITED_STANDARD_PLAN, } from '../../../../../define/consts/proffit_search/proffit_search_service';
import { propArrayShape, propBool, propFunc, propStr, } from '../../../../../helpers/custom-prop-types';
import { usePromiseDoingCallback, useUnmountRef, } from '../../../../../helpers/use/useHook';
import LockIcon from '../../../../Icon/Svg/LockIcon';
import OfficePptIcon from '../../../../Icon/Svg/OfficePptIcon';
import SubmitButton from '../../../../Ui/Button/SubmitButton';
import HtmlLink from '../../../../Ui/Common/HtmlLink';
import Hover from '../../../../Ui/System/Hover';
const ActionPptxButton = (props) => {
    const { buttonClassName, isBlockDownload, isFree, isNotReadyPptx, onClickLockItem, onClickPptx: originalOnClickPptx, position, selectSlides, showLabel, } = props;
    const unMountRef = useUnmountRef();
    const rawOnClickSave = useCallback((e) => __awaiter(void 0, void 0, void 0, function* () {
        yield originalOnClickPptx(selectSlides, e);
    }), [originalOnClickPptx, selectSlides]);
    const checkedCount = selectSlides.length > 0;
    const [onClickPptx, pptxDownloading] = usePromiseDoingCallback(rawOnClickSave, unMountRef);
    // ダウンロード禁止判定
    const isDisabledPptxDownload = !checkedCount || isBlockDownload || isNotReadyPptx || isFree;
    const tooltipMessage = useMemo(() => {
        let message = '';
        if (isBlockDownload) {
            message = PROFFIT_SEARCH_ACTION_TOOLTIP_BLOCK_SHARE;
        }
        else if (isFree) {
            message = PROFFIT_SEARCH_ACTION_TOOLTIP_LIMITED_STANDARD_PLAN;
        }
        else if (isNotReadyPptx) {
            message = PROFFIT_SEARCH_ACTION_TOOLTIP_IS_NOT_READY_PPTX;
        }
        return message;
    }, [isFree, isBlockDownload, isNotReadyPptx]);
    return (_jsx("div", Object.assign({ className: 'slide_action_button_box' }, { children: _jsx(Hover, { children: _jsxs("div", Object.assign({ className: 'slide_action_button_box_content' }, { children: [isDisabledPptxDownload && (_jsx("div", Object.assign({ className: 'slide_action_button_lock' }, { children: _jsx(Tooltip, Object.assign({ animation: 'scale', arrow: true, disabled: !isBlockDownload && !isNotReadyPptx && !isFree, duration: 100, html: _jsx("div", { children: tooltipMessage }), position: position === 'right' ? 'left-start' : 'top', zIndex: 1011 }, { children: isBlockDownload || isNotReadyPptx ? (_jsx(LockIcon, {})) : (_jsx(HtmlLink, Object.assign({ isNoLinkComponent: onClickLockItem ? 'button' : undefined, onClick: onClickLockItem, to: '/proffit_search/account_plan' }, { children: _jsx(LockIcon, {}) }))) })) }))), _jsx(SubmitButton, { className: clsx('icon_box', buttonClassName), isDisabled: isDisabledPptxDownload, isLoading: pptxDownloading, onClick: onClickPptx, text: _jsx(OfficePptIcon, {}), type: 'button' }), showLabel && _jsx("span", Object.assign({ className: 'button_text' }, { children: "PPT\u5909\u63DB" }))] })) }) })));
};
ActionPptxButton.propTypes = {
    buttonClassName: propStr().isRequired,
    isBlockDownload: propBool().isRequired,
    isFree: propBool().isRequired,
    isNotReadyPptx: propBool().isRequired,
    onClickLockItem: propFunc().isRequired,
    onClickPptx: propFunc().isRequired,
    position: propStr().isRequired,
    selectSlides: propArrayShape().isRequired,
    showLabel: propBool(),
};
ActionPptxButton.defaultProps = {
    showLabel: true,
};
export default ActionPptxButton;
